import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import Info from 'components/shared/Info'
import { FormattedMessage } from 'react-intl'
import { useResolutions } from 'store/resolutions'
import Price from 'components/shared/Price'
import { formatPrice } from 'helpers/helpers'
import { useAppSelector } from 'store/hooks'
import { SummaryListWrapper, LoaderWrapper } from './styles'
import { useCart } from 'store/cart-slice/hooks'
import Loader from 'components/shared/Loader'
import AutoPromotionsInfo from 'components/global/AutoPromotionsInfo'

interface SummaryProps {
    productList: React.ReactNode
}

const Summary = ({ productList }: SummaryProps) => {
    const { cart } = useAppSelector((state) => state.cart)
    const { appMode } = useAppSelector((state) => state.general)
    const { isTablet } = useResolutions()
    const {
        totalPrice,
        youSave,
        couponSimulationPrice,
        payByCardPrice,
        beforeDiscountPrice,
    } = cart || {}
    const { isSummaryFetching } = useCart()

    const orderSumPrice = (totalPrice ?? 0) - (payByCardPrice ?? 0)

    return (
        <SummaryListWrapper
            gap={16}
            pt={[0, 16]}
            pb={[0, 16]}
            direction="column"
            mode={appMode}
        >
            {!isTablet && (
                <Text
                    variant="heading4"
                    color="grayscale_900"
                    pl={16}
                    pb={isSummaryFetching ? 16 : 0}
                >
                    <FormattedMessage
                        id="global.summary.section_caption"
                        defaultMessage="Podsumowanie"
                    />
                </Text>
            )}
            {isSummaryFetching ? (
                <LoaderWrapper justify="center" align="center" pt={8}>
                    <Loader />
                </LoaderWrapper>
            ) : (
                <>
                    <Box gap={16}>
                        {isTablet && (
                            <AutoPromotionsInfo mt={-12} isFullWidth />
                        )}
                        {productList}
                    </Box>
                    <Box align="stretch" gap={8}>
                        <Box
                            direction="row"
                            align="flex-end"
                            justify="space-between"
                        >
                            <Text
                                variant={isTablet ? 'body' : 'bodySmall'}
                                color="secondary_500"
                                mb={6}
                            >
                                <FormattedMessage
                                    id="global.price.label_total_summary"
                                    defaultMessage="Do zapłaty"
                                />
                                :
                            </Text>
                            <Box align="flex-end">
                                {!!beforeDiscountPrice &&
                                    beforeDiscountPrice > 0 && (
                                        <Price
                                            value={beforeDiscountPrice || 0}
                                            size="body"
                                            color="grayscale_700"
                                            crossedOutVariant="gray"
                                        />
                                    )}
                                <Price
                                    value={orderSumPrice || 0}
                                    size="heading2"
                                />
                            </Box>
                        </Box>

                        {!isTablet && <AutoPromotionsInfo />}

                        {!!couponSimulationPrice && !youSave && (
                            <Info
                                color="success"
                                hasSmallFont={true}
                                hasIcon={false}
                            >
                                <FormattedMessage
                                    id="global.msg.price_with_coupon"
                                    defaultMessage="Cena z kodem BLACKWEEKEND: {ammount} zł"
                                    values={{
                                        amount: formatPrice(
                                            couponSimulationPrice,
                                            false
                                        ),
                                    }}
                                />
                            </Info>
                        )}
                    </Box>
                </>
            )}
        </SummaryListWrapper>
    )
}

export default Summary
